import React, { FC, useContext }    from 'react';
import classNames                   from 'classnames';
import { ToastCard, IToast }        from '../toast-card/ToastCard';
import { DynamicComponentsContext } from '../../contexts';
import { StyledContainer }          from '../../containers';
import { Position }                 from '../../../types';

interface Props {}

const defaultProps: Props = {}

const Toasts: FC<Props> = ( props ) => {
	
	// Pull from the system toast registry, no
	let { toasts: [ toasts ] } = useContext( DynamicComponentsContext );
	
	let classes = classNames( [
		'flexbox',
		'flexbox--align-end',
		'flexbox--cols',
	] );
	
	let toastItems = toasts.items.map( ( toast: IToast ) => {
		return <ToastCard key={ toast.id } item={ toast }/>
	});
	
	return (
		/* Toasts should remain above any modal construct, which requires a higher z-index */
		<StyledContainer
			position={ Position.FIXED }
			top={ 10 }
			right={ 10 }
			style={ { zIndex: 2000 } }
			className={ classes }>
			
			{ toastItems }
		
		</StyledContainer>
	);
	
};

Toasts.defaultProps = defaultProps;

export { Toasts }
